import { render, staticRenderFns } from "./salesOrder.vue?vue&type=template&id=051123fe&scoped=true&"
import script from "./salesOrder.vue?vue&type=script&lang=js&"
export * from "./salesOrder.vue?vue&type=script&lang=js&"
import style0 from "./salesOrder.vue?vue&type=style&index=0&id=051123fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051123fe",
  null
  
)

export default component.exports